import { useEffect } from 'react';
import { Tag } from 'animal-island-ui';
import { useAppStore } from '../store/useAppStore';
import clsx from 'clsx';

export default function SchedulePanel({ eventId }: { eventId: number }) {
  const { milestones, toggleMilestone, loadMilestones } = useAppStore();
  const list = milestones[eventId] || [];
  const today = new Date();

  useEffect(() => {
    loadMilestones(eventId);
  }, [eventId, loadMilestones]);

  return (
    <div id="panel-schedule" className="ac-card p-5">
      <div id="schedule-header" className="flex items-center gap-2 mb-4">
        <span className="text-2xl">📅</span>
        <h3 className="font-bold text-lg text-gray-800">日程里程碑</h3>
        <span className="text-xs text-gray-400 ml-auto">诸神催办</span>
      </div>

      {/* 时间轴 */}
      <div className="relative">
        <div className="absolute left-4 top-0 bottom-0 w-0.5 bg-amber-200" />
        <div className="space-y-3">
          {list.map((m) => {
            const date = new Date(m.date);
            const isPast = date < today;
            const god = useAppStore.getState().gods[m.god];

            return (
              <div key={m.id} className="relative flex items-start gap-4 pl-2">
                {/* 节点圆点 */}
                <div
                  className={clsx(
                    'relative z-10 w-8 h-8 rounded-full flex items-center justify-center text-sm border-2 flex-shrink-0',
                    m.done ? 'bg-green-100 border-green-400' : isPast ? 'bg-gray-100 border-gray-300' : 'bg-amber-100 border-amber-400'
                  )}
                >
                  {m.done ? '✓' : god?.emoji}
                </div>

                {/* 内容 */}
                <div className={clsx(
                  'flex-1 p-3 rounded-xl border transition-all',
                  m.done ? 'bg-green-50 border-green-200' : isPast ? 'bg-gray-50 border-gray-200 opacity-60' : 'bg-white border-amber-200'
                )}>
                  <div className="flex items-center justify-between">
                    <span className={clsx('font-medium', m.done && 'line-through text-gray-400')}>
                      {m.title}
                    </span>
                    {m.daysBefore > 0 && !m.done && (
                      <Tag color="app-red" variant="solid" size="small">
                        T-{m.daysBefore}天
                      </Tag>
                    )}
                    {m.daysBefore === 0 && !m.done && (
                      <Tag color="app-red" variant="solid" size="small" className="animate-pulse">
                        今天！
                      </Tag>
                    )}
                  </div>
                  <div className="flex items-center gap-2 mt-1">
                    <span className="text-xs text-gray-400">{m.date}</span>
                    <span className="text-xs text-gray-300">·</span>
                    <span className="text-xs" style={{ color: god?.color }}>{god?.name}催办</span>
                  </div>
                </div>

                {/* 完成按钮 */}
                {!m.done && (
                  <button
                    onClick={() => toggleMilestone(eventId, m.id)}
                    className="self-center text-xs px-2 py-1 rounded-lg bg-green-50 text-green-600 border border-green-200 hover:bg-green-100"
                  >
                    完成
                  </button>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
